import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14.22 18"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.74 5.54H4.18c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h8.56c.28 0 .5.22.5.5s-.23.5-.5.5zm-11.01.25a.753.753 0 0 1-.69-1.04c.04-.09.09-.17.16-.24.2-.21.54-.28.82-.17.09.04.17.1.24.17s.13.15.16.24a.75.75 0 0 1-.69 1.04zM12.74 9.5H4.17c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h8.56c.28 0 .5.22.5.5s-.22.5-.49.5zm-11.01.25a.75.75 0 1 1 0-1.499.75.75 0 0 1 0 1.499zm11.01 3.71H4.18c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h8.56c.28 0 .5.22.5.5s-.23.5-.5.5zm-11.01.25c-.1 0-.2-.02-.29-.05a.807.807 0 0 1-.4-.41.75.75 0 0 1 .4-.98c.19-.07.39-.08.58 0a.75.75 0 0 1-.29 1.44z"
    }, null, -1)
  ])))
}
export default { render };